import {actionTypes} from 'constants/constants';

const initialState = {};

export default function userInfo (state = initialState, action) {
    switch (action.type) {
        case actionTypes.READING_GOODNIGHT_2019_UPDATE:
            return Object.assign({},state,action.data);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/thefair/goodnight2019.js